import { UserCXAdapter } from '~/components/ClientExperience/services/adapters/user-cx.adapter';

export class UserCXService extends UserCXAdapter {}
